module.exports = __webpack_public_path__ + "static/media/j-burrows.1f1b583d.png";